import { AnimatePresence, motion } from 'framer-motion';
import React, { useState } from 'react';
import AnimatedBackground from '../../../utils/AnimatedBackground';
import Footer from '../../../utils/Footer';
import TopBar from '../../../utils/TopBar';
import { useInvestmentsCrypto } from '../../hooks/import/CryptoImport';
import ProgressIndicator from '../utils/progress-indicator';
import StepContent from '../utils/step-content-crypto';

const CryptoImport: React.FC = () => {
  const {
    currentStep,
    formData,
    showCustomTicker,
    totalSteps,
    handleInputChange,
    handleSelectOption,
    navigateToStep,
    handleSubmit: handleFormSubmit,
  } = useInvestmentsCrypto();

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (currentStep === 6) {
      setIsSubmitting(true);
      try {
        await handleFormSubmit(e);
      } catch (error) {
        console.error('Error submitting form:', error);
      } finally {
        setIsSubmitting(false);
      }
    } else {
      navigateToStep(currentStep + 1);
    }
  };

  return (
    <div className="min-h-screen h-screen bg-[#0a0a0a] flex flex-col relative overflow-hidden">
      <AnimatedBackground />
      <div className="relative z-10 flex flex-col h-full">
        <TopBar
          title="Import Investments"
          subtitle="Add new investment records to your account"
        />

        <main className="flex-grow flex items-center justify-center py-6 relative z-10">
          <div className="py-4 px-4 w-full">
            <div className="bg-black border border-gray-700 shadow sm:rounded-lg max-w-2xl mx-auto">
              <div className="px-8 py-6">
                <ProgressIndicator currentStep={currentStep} totalSteps={totalSteps} />
                <form onSubmit={handleSubmit}>
                  <AnimatePresence mode="wait">
                    <motion.div
                      key={currentStep}
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: -20 }}
                      transition={{ duration: 0.3 }}
                    >
                      <StepContent
                        currentStep={currentStep}
                        formData={formData}
                        showCustomTicker={showCustomTicker}
                        handleInputChange={handleInputChange}
                        handleSelectOption={handleSelectOption}
                        isSubmitting={isSubmitting}
                      />
                    </motion.div>
                  </AnimatePresence>
                  {currentStep !== 6 ? (
                    <div className="mt-6 flex justify-end space-x-4">
                      {currentStep > 1 && (
                        <button
                          type="button"
                          onClick={() => navigateToStep(currentStep - 1)}
                          className="px-6 py-2 bg-black border border-gray-800 text-white rounded-md hover:bg-gray-900 transition-colors"
                        >
                          Previous
                        </button>
                      )}
                      <button
                        type="button"
                        onClick={() => navigateToStep(currentStep + 1)}
                        className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-500 transition-colors"
                      >
                        Next
                      </button>
                    </div>
                  ) : (
                    <div className="mt-6 flex justify-end space-x-4">
                      <button
                        type="button"
                        onClick={handleSubmit}
                        disabled={isSubmitting}
                        className="px-6 py-2 bg-green-600 text-white rounded-md hover:bg-green-500 transition-colors disabled:opacity-50"
                      >
                        {isSubmitting ? 'Submitting...' : 'Confirm Import'}
                      </button>
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default CryptoImport;